import { render } from "./App.vue?vue&type=template&id=136fd7b0"
const script = {}

import "./App.vue?vue&type=style&index=0&id=136fd7b0&lang=sass"

import exportComponent from "/Users/dominik/Code/Meine Projekte/BigTimer/Timer Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__